/* eslint-disable no-restricted-globals */
/* eslint-disable no-prototype-builtins */
/* eslint-disable no-shadow */
/* eslint-disable react/prop-types */
/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-restricted-syntax */
/* eslint-disable prefer-destructuring */
/* eslint-disable react/jsx-props-no-spreading */
import queryString from "query-string";
import React, { useContext, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import * as Sentry from "@sentry/react";
import moment from "moment/moment";
import EmptyFileIcon from "../../../../assets/svg/EmptyFile";
import ReloadIcon from "../../../../assets/svg/ReloadIcon";
import SearchIconWithPeople from "../../../../assets/svg/SearchIconWithPeople";
import AppliedFilter from "../../../../components/common/AppliedFilter/AppliedFilter";
import Loader from "../../../../components/common/Loader/Loader";
import {
  AppliedFilterLabelMap,
  DATES,
  EVENT_NAME,
  Constants,
  AlertStatus,
} from "../../../../contants";
import useParamsQuery from "../../../../hooks/useParamsQuery";
import { selectOSKeysByUserRole } from "../../../../redux/selectors/user";
import Reports from "../../../../services/api/reports";
import { formDataToObject, isEmptyObj } from "../../../../utils/helper";
import styles from "../FriendSearch.styles";
import ReportTable from "../FriendsReportsTable/ChangeToMemberTrendsTable";
// import OrganizationSearch from "../../Components/OrganizationSearch";
import OrganizationSearch from "../../SubscriptionReports/OrganizationSearchReports";
import AdvanceSearch from "../../SubscriptionReports/Components/AdvanceSearchSubscriptionTrends";

import Popover from "../../../member/MemberSearch/Popover/Popover";
import {
  getFilters,
  getFormattedQuery,
  getRoutePathforChangedToMemberTrends,
  handleDependencyFilter,
} from "./utils";
import { ToastAlertContext } from "../../../../config/providers/ToastAlert";
import { SET_PERIOD_DATE } from "../../../../redux/actionTypes/meta";
import ExportButton from "./Components/ExportButton";

const LOADER_DELAY = 1000;
const PAGE = "page";

const FILTER_KEYS = {
  PERSONAL_FILTER: "personal-filter",
  ORGANISATION_STRUCTURE_FILTER: "orgainsation-structure-filter",
};

const SEARCH_FILTERS = [
  {
    key: FILTER_KEYS.PERSONAL_FILTER,
    component: AdvanceSearch,
    popOverprops: {
      heading: "Advanced Search",
      minHeight: 300,
      minWidth: 513,
    },
  },
  {
    key: FILTER_KEYS.ORGANISATION_STRUCTURE_FILTER,
    component: OrganizationSearch,
    popOverprops: { heading: "Organization Structure", minWidth: 413 },
  },
];
const filterOrder = [
  "areaId",
  "zoneId",
  "regionId",
  "chapterId",
  "districtId",
  "blockId",
];

const initialFormValue = {
  dateFrom: "",
  dateTo: "",
};

function FriendToMemberTrends() {
  const [searchData, setSearchData] = useState([]);
  const [appliedFilters, setAppliedFilters] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const formRef = useRef(null);
  const navigate = useNavigate();
  const metaData = useSelector((state) => state.meta);
  const disabledOSKeys = useSelector(selectOSKeysByUserRole);
  const { getQueryObject, getQueryParams, urlSearchParams } = useParamsQuery();
  // const [currentPage, setCurrentPage] = useState(0);
  const [pageSize, setPageSize] = useState(Constants.DEFAULT_PAGE_SIZE);
  const toast = useContext(ToastAlertContext);
  const [dateFrom, setDateFrom] = useState(initialFormValue.dateFrom);
  const [dateTo, setDateTo] = useState(initialFormValue.dateTo);
  const [dateValueFrom, setDateValueFrom] = useState(null);
  const [dateValueTo, setDateValueTo] = useState(null);
  const dispatch = useDispatch();

  const clearFormRef = () => {
    Object.keys(AppliedFilterLabelMap).forEach((key) => {
      if (formRef.current[key]) {
        formRef.current[key].value = "";
        formRef.current[key]?.blur();
      }
    });
  };

  const setMetaDataInRedux = (type, payload) => {
    dispatch({
      type,
      payload,
    });
  };

  const resetFormState = () => {
    setSearchData([]);
    setAppliedFilters([]);
    clearFormRef();
  };

  const initializeFormState = (queryObject) => {
    if (!isEmptyObj(queryObject)) {
      clearFormRef();
      Object.keys(queryObject).forEach((key) => {
        if (formRef.current[key]) {
          formRef.current[key].value = queryObject[key];
        }
      });
    }
  };

  const updateSearchParam = (query) => {
    if (query?.length) {
      navigate(`${getRoutePathforChangedToMemberTrends()}?${query}`);
    } else {
      navigate(`${getRoutePathforChangedToMemberTrends()}`);
    }
  };

  const removeKeyFromQuery = (queryObject, filterKey) => {
    let updatedQuery = {
      ...queryObject,
    };

    if (DATES.includes(filterKey)) {
      delete updatedQuery[filterKey];
      delete updatedQuery[`${filterKey.split("From")[0]}To`];
    } else {
      delete updatedQuery[filterKey];
    }

    if (Object.keys(updatedQuery).length === 1 && PAGE in updatedQuery) {
      delete updatedQuery[PAGE];
    }

    updatedQuery = handleDependencyFilter(updatedQuery, disabledOSKeys);

    return updatedQuery;
  };

  const handleDateChangeFrom = (newValue) => {
    if (newValue !== null) {
      const newDateValue = new Date(newValue);
      const selectedDate = moment(newDateValue);
      const firstDayOfMonth = selectedDate.clone().startOf("month");
      const localFirstDayOfMonth = moment(firstDayOfMonth).format("YYYY-MM-DD");

      setDateFrom(localFirstDayOfMonth);
    } else {
      // Handle case when the user clears the date
      setDateFrom("");
    }

    setDateValueFrom(newValue);
  };

  const handleDateChangeTo = (newValue) => {
    if (newValue !== null) {
      const newDateValue = new Date(newValue);
      const selectedDate = moment(newDateValue);
      const lastDayOfMonth = selectedDate.clone().endOf("month");
      const localLastDayOfMonth = moment(lastDayOfMonth).format("YYYY-MM-DD");

      setDateTo(localLastDayOfMonth);
    } else {
      setDateTo("");
    }

    setDateValueTo(newValue);
  };

  const onRemoveFilter = (filterKey) => {
    let queryObject = getQueryObject();
    queryObject = removeKeyFromQuery(queryObject, filterKey);
    const updatedQuery = queryString.stringify(queryObject);
    updateSearchParam(updatedQuery);
  };

  const validateAndFetchData = (formattedQuery, toast, setIsLoading) => {
    if (
      !formattedQuery.hasOwnProperty("areaId") ||
      formattedQuery.areaId === ""
    ) {
      toast.show("Please enter Area", AlertStatus.ERROR);
      setIsLoading(false);
      return false;
    }

    if (
      !formattedQuery.hasOwnProperty("dateFrom") ||
      formattedQuery.dateFrom === "" ||
      !formattedQuery.hasOwnProperty("dateTo") ||
      formattedQuery.dateTo === ""
    ) {
      toast.show("Please enter date", AlertStatus.ERROR);
      setIsLoading(false);
      return false;
    }

    // Validate date range
    const dateFrom = new Date(formattedQuery.dateFrom);
    const dateTo = new Date(formattedQuery.dateTo);

    if (isNaN(dateFrom) || isNaN(dateTo)) {
      toast.show("Invalid date format", AlertStatus.ERROR);
      setIsLoading(false);
      return false;
    }

    if (dateFrom > dateTo) {
      toast.show("Start date cannot be after the end date", AlertStatus.ERROR);
      setIsLoading(false);
      return false;
    }

    return true;
  };

  const fetchSearchData = async (queryParams) => {
    try {
      setIsLoading(true);
      const formattedQuery = getFormattedQuery({
        ...queryParams,
      });

      if (validateAndFetchData(formattedQuery, toast, setIsLoading)) {
        const response = await Reports.FriendChangeToMemberTrendsReport(
          formattedQuery
        );
        if (response.code === 200 && response.message === "") {
          setIsLoading(false);
        }

        const { data } = response;

        // Showing some delay to avoid loader flicker issue
        setSearchData(data);
        // setCurrentPage(data?.number);
        setPageSize(pageSize);
        setTimeout(() => {
          setIsLoading(false);
        }, LOADER_DELAY);
      }
    } catch (error) {
      setIsLoading(false);
      toast.show(
        error.message || "Something went wrong. Please contact support.",
        AlertStatus.ERROR
      );
      Sentry.captureException(error);
    }
  };

  const onSubmit = (e) => {
    e.preventDefault();

    const rawFormData = new FormData(formRef.current);
    const formData = formDataToObject(rawFormData);
    if (dateFrom !== "") {
      formData.dateFrom = dateFrom;
    }
    if (dateTo !== "") {
      formData.dateTo = dateTo;
    }
    setMetaDataInRedux(
      SET_PERIOD_DATE,
      moment(formData.dateTo).format("MMMM, YYYY")
    );
    const query = queryString.stringify(formData);

    document.dispatchEvent(new Event(EVENT_NAME));
    updateSearchParam(query);
  };

  useEffect(() => {
    const queryObject = getQueryObject();
    if (!isEmptyObj(queryObject)) {
      const [query] = getQueryParams(queryObject);
      fetchSearchData(query);
      initializeFormState(query);
    } else {
      resetFormState();
    }
  }, [urlSearchParams.toString()]);

  useEffect(() => {
    const queryObject = getQueryObject();
    if (!isEmptyObj(queryObject)) {
      const query = getQueryParams(queryObject)[0];
      setAppliedFilters(getFilters(query, metaData, disabledOSKeys));
    }
  }, [metaData, urlSearchParams.toString()]);

  const onRefresh = () => {
    const queryObject = getQueryObject();
    const [query] = getQueryParams(queryObject);
    fetchSearchData(query);
  };

  const clearAllFilter = () => {
    updateSearchParam();
  };
  const orderedFilters = filterOrder
    .map((filterKey) =>
      appliedFilters.find((filter) => filter.key === filterKey)
    )
    .filter(Boolean);

  const additionalFilters = appliedFilters.filter(
    (filter) => !filterOrder.includes(filter.key)
  );

  return (
    <div style={styles.container}>
      <div style={styles.filter}>
        <form style={styles.left} onSubmit={onSubmit} ref={formRef}>
          {SEARCH_FILTERS.map(({ component: Component, popOverprops, key }) => (
            <Popover key={key} {...popOverprops}>
              <Component
                formRef={formRef}
                disabledOSKeys={disabledOSKeys}
                handleDateChangeFrom={handleDateChangeFrom}
                handleDateChangeTo={handleDateChangeTo}
                dateValueFrom={dateValueFrom}
                dateValueTo={dateValueTo}
              />
            </Popover>
          ))}
        </form>
        <div style={styles.right}>
          <ExportButton
            data={searchData}
            exportFunction={Reports.downloadFriendChangeToMemberTrendReport}
          />
          <div style={styles.reload} onClick={onRefresh}>
            <ReloadIcon />
          </div>
        </div>
      </div>
      <div style={styles.main}>
        {appliedFilters.length ? (
          <div style={styles.filterWrapper}>
            <div style={styles.filterContainer}>
              {orderedFilters.map((filter) => (
                <AppliedFilter
                  key={filter.key}
                  filter={filter}
                  onRemove={onRemoveFilter}
                />
              ))}
              {additionalFilters.map((filter) => (
                <AppliedFilter
                  key={filter.key}
                  filter={filter}
                  onRemove={onRemoveFilter}
                />
              ))}
            </div>
            <div style={styles.clearAll} onClick={clearAllFilter}>
              Clear
            </div>
          </div>
        ) : null}
        {searchData?.length ? (
          <ReportTable
            searchData={searchData}
            // currentPage={currentPage}
            // pageSize={pageSize}
          />
        ) : (
          <div style={styles.initialContent}>
            {appliedFilters.length ? (
              <>
                <EmptyFileIcon width={100} />
                <span style={styles.text}>
                  No data found with current Filters
                </span>
              </>
            ) : (
              <>
                <SearchIconWithPeople width={100} />
                <span style={styles.text}>Choose your Search Filter</span>
              </>
            )}
          </div>
        )}
      </div>
      {isLoading && <Loader />}
    </div>
  );
}

export default FriendToMemberTrends;
